import { render, staticRenderFns } from "./IconContinue.vue?vue&type=template&id=3e5a8f56"
import script from "./IconContinue.vue?vue&type=script&lang=js"
export * from "./IconContinue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports